export default "__VITE_ASSET__DObMFbZW__"